import React, { useState } from 'react'
import { Button, Modal } from 'antd'

import Attention from 'assets/images/icons/Attention.svg'
import { CloseIco } from '../../../modules/CustomIcons'

import './index.scss'
import { useTranslation } from 'react-i18next'

interface PopConfirmProps {
  children: React.ReactNode
  handleRemoveRow: (rowselected: Array<string>) => void
  visible: boolean
  closeModal: () => void
  rowSelected: any
}
const PopConfirm: React.FC<PopConfirmProps> = ({
  visible,
  handleRemoveRow,
  closeModal,
}) => {
  const {t} = useTranslation();
  // const [visible, setVisible] = useState(false)
  const handleRemoveRowTable =() => {
    //@ts-ignore
    handleRemoveRow()
    closeModal()
  }
  return (
    <Modal
      visible={visible}
      onCancel={closeModal}
      centered
      closable={false}
      className="manage_faster_menus no_footer row-delete-modal"
      footer={
        <div className="flex justify_between align_center">
          <Button
            className="light-button refresh_btn next_modal_cancel_btn btn flex align_center"
            onClick={closeModal}
          >
            {t("common.cancel")}
          </Button>
          <Button
            className="blue-button next_btn btn flex align_center"
            onClick={handleRemoveRowTable}
          >
            {t("transfers.delete")}
          </Button>
        </div>
      }
      okText={t("transfers.delete")}
      cancelText={t("common.cancel")}
    >
      {/* {children} */}
      <div className="ant-popconfirm__content">
        <header>
          {t("notification.attention")}
          <Button type='ghost' style={{position: 'relative', right: 20}} icon={<CloseIco/>} onClick={() => closeModal()}/>
        </header>
        <div className="flex" style={{ flexDirection: 'column' }}>
          <img src={Attention} />
          <p>{t("salary.deleteRow")}</p>
        </div>
      </div>
    </Modal>
  )
}

export default PopConfirm
